// Auth Mixin 

import * as authRequest from '../request/auth'

export default {
  data() {
    return {
      validando_captcha: false,
      captcha_invalid: false
    }
  },
  methods: {
    validateCaptcha(callback) {
      let vm = this;
      this.validando_captcha = true;
      let data = new FormData();
      data.append('captcha_c', this.captcha);
      authRequest.validateCaptha(data).then(response => {
        if (response.data.success) {
          vm.captcha_invalid = false;
          if (callback) {
            callback(response.data);
          }
        } else {
          vm.captcha_invalid = true; // 
        }
        vm.validando_captcha = false;
      }).catch(err_ => {
        console.log(err_);
      })
    }
  }
}